import * as React from 'react';
import { Link } from 'react-router-dom';
export var StyleableLink = function (_a) {
    var children = _a.children, className = _a.className, to = _a.to, onClick = _a.onClick;
    return (React.createElement(Link, { to: to, className: className, onClick: onClick }, children));
};
